import React, { lazy, Suspense } from 'react';
import PrivateRoute from "../../routes/PrivateRoute";
import PublicRoute from "../../routes/PublicRoute";
import { Spinner } from '../Common/Spinner';

const CallForProposalsListTable = lazy(() => import('./List/CallForProposalsTable'));
const CallForProposalsForm = lazy(() => import('./CallForProposalsForm'));
const CallForProposalsInstructionPage = lazy(() => import('./CallForProposalsInstructionPage'));
const SubmissionForm = lazy(() => import('./Submissions/SubmissionForm'));
const SubmissionList = lazy(() => import('./Submissions/SubmissionList'));

const CallForProposalsRouter = (props) => (
  <Suspense fallback={<Spinner />}>
    <PrivateRoute path="/list/call_for_proposals" searchString={props.searchString} component={CallForProposalsListTable} exact />
    <PrivateRoute path="/call_for_proposals/:id?" component={CallForProposalsForm} exact />
    <PublicRoute path="/call_for_proposals/instruction/:organization_id/:id" component={CallForProposalsInstructionPage} exact />
    <PublicRoute path="/call_for_proposals/submission/registration/:organization_id/:cf_proposal_id" component={SubmissionForm} exact />
    <PrivateRoute path="/call_for_proposals/submissions/:organization_id/:cf_proposal_id" component={SubmissionList} exact />
  </Suspense>
);

export default CallForProposalsRouter;